import { useTranslation } from "@impero-com/common/utils/i18n";
import { ActionMenuProps, emitNotification } from "@impero-com/ui";

import LinkIconSvg from "img/link.svg";
import { copyDataToClipboard } from "utils/clipboard";

/** Action menu for the control activities list pages: copies the current url. */
export function useCopyLinkAction(): ActionMenuProps {
    const { t } = useTranslation();

    const onCopyLink = () => {
        copyDataToClipboard(window.location.href);
        emitNotification("success", t("ShareableLinkPopup_CopiedToClipboard"));
    };

    return {
        id: "control-results-action-menu",
        actions: [
            {
                id: "shareable-link-create-new",
                label: t("ShareableLink_CreateNew"),
                icon: { svg: LinkIconSvg },
                onClick: onCopyLink,
            },
        ],
    };
}
